export default __webpack_public_path__ + "static/media/img_chart_grade_S.280e85451e4defd116fba465187d03c3.svg";